import {OrderStatus, PaymentStatus, PaymentType, ServiceType} from "../../enums/enums";
import {camelToTitle, generateColumnClass,getColumnClasses,filterPresets} from "../Utility";
import {useDispatch, useSelector} from "react-redux";
import {onClearFilter, onChangeFilter} from "../../store/view-order-filter-slice"
import React, {useEffect,useRef} from "react";

const FilterOrders = ({fetchOrders, fetchOrdersByFilter, visibleFilters = filterPresets.allFilter, data = {}, columns}) => {
    const columnClass = columns ? generateColumnClass(columns) : 'col-md-6 col-xl-3 col-xxl-2';
    const dispatch = useDispatch();
    const filters = useSelector(state => state.viewOrderFilter)
    const userRole = useSelector((state) => state.auth.selectedRole);
    const isVisible = (key) => visibleFilters.includes(key);
    const { leftCol, rightCol } = getColumnClasses(visibleFilters);
    const filterState = useSelector(state => state.viewOrderFilter); // or wherever filters are stored
    const hasSetDefaultRef = useRef(false);

    const onClearFilterHandler = () => {
        dispatch(onClearFilter());

        if (visibleFilters === filterPresets.customerOrderFilter) {
            dispatch(fetchOrders({
                ...userRole,
                ...(Object.keys(data || {}).length > 0 ? data : {}),
                queryString:"paymentStatus=0"
            }));
        } else {
            dispatch(fetchOrders(userRole));
        }
    };

    const onFilterOrder = (appliedFilters) => {
        const query = {};
        Object.entries(appliedFilters).forEach(([key, value]) => {
            if (value !== "") {
                query[key] = value;
            }
        });

        const queryString = new URLSearchParams(query).toString();
        dispatch(fetchOrdersByFilter({
            ...userRole,
            ...(Object.keys(data).length > 0 ? data : {}),// include `data` only if it's truthy (not null or undefined)
            queryString
        }));
    };

    const handleChange = (key, value) => {
        dispatch(onChangeFilter({key, value}));
    };

    const onApplyFilter = () => {
        onFilterOrder(filters);
    };

    useEffect(() => {
        if (
            visibleFilters === filterPresets.customerOrderFilter &&
            !hasSetDefaultRef.current &&
            (filterState.paymentStatus === "" || filterState.paymentStatus === undefined)
        ) {
            dispatch(onChangeFilter({ key: "paymentStatus", value: PaymentStatus.Pending }));
            hasSetDefaultRef.current = true; // Prevent infinite loop
        }
    }, [visibleFilters, filterState.paymentStatus, dispatch]);

    useEffect(() => {
        if (visibleFilters !== filterPresets.customerOrderFilter) {
            dispatch(onClearFilter());
            hasSetDefaultRef.current = false; // Reset so default can apply again if needed
        }
    }, [visibleFilters, dispatch]);

    return (
        <>
            {/*Filter the orders*/}
            <div className="row">
                <div className={leftCol}>
                    <div className="row mb-5">
                        {isVisible("serviceType") && (<div className={columnClass}>
                            <label className="fs-md fw-medium">Service type</label>
                            <select
                                className="form-select form-select-sm"
                                name="serviceType"
                                value={filters.serviceType}
                                onChange={(e) => handleChange("serviceType", e.target.value)}
                            >
                                <option value="">--Select--</option>
                                {
                                    Object.keys(ServiceType).map((key) => {
                                        const value = ServiceType[key]
                                        return <option key={key} value={value}>{camelToTitle(key)}</option>
                                    })
                                }
                            </select>
                        </div>)}

                        {isVisible("paymentType") && (<div className={columnClass}>
                            <label className="fs-md fw-medium">Payment type</label>
                            <select
                                className="form-select form-select-sm"
                                name="paymentType"
                                value={filters.paymentType}
                                onChange={(e) => handleChange("paymentType", e.target.value)}
                            >
                                <option value="">--Select--</option>
                                {
                                    Object.keys(PaymentType).map((key) => {
                                        const value = PaymentType[key];
                                        return <option key={key} value={value}>{camelToTitle(key)}</option>
                                    })
                                }
                            </select>
                        </div>)}

                        {isVisible("paymentStatus") && (<div className={columnClass}>
                            <label className="fs-md fw-medium">Payment status</label>
                            <select
                                className="form-select form-select-sm"
                                name="paymentStatus"
                                value={filters.paymentStatus}
                                onChange={(e) => handleChange("paymentStatus", e.target.value)}
                            >
                                <option value="">--Select--</option>
                                {
                                    Object.keys(PaymentStatus).map((key) => {
                                        const value = PaymentStatus[key];
                                        return <option key={key} value={value}>{camelToTitle(key)}</option>
                                    })
                                }
                            </select>
                        </div>)}

                        {isVisible("orderStatus") && (<div className={columnClass}>
                            <label className="fs-md fw-medium">Order status</label>
                            <select
                                className="form-select form-select-sm"
                                name="orderStatus"
                                value={filters.orderStatus}
                                onChange={(e) => handleChange("orderStatus", e.target.value)}
                            >
                                <option value="">--Select--</option>
                                {
                                    Object.keys(OrderStatus).map((key) => {
                                        const value = OrderStatus[key];
                                        return <option key={key} value={value}>{camelToTitle(key)}</option>
                                    })
                                }
                            </select>
                        </div>)}

                        {isVisible("startDate") && (<div className={columnClass}>
                            <label className="me-1 fs-md fw-medium">Start Date:</label>
                            <input
                                className="form-control form-control-sm"
                                name="startDate"
                                type="date"
                                value={filters.startDate}
                                onChange={(e) => handleChange("startDate", e.target.value)}
                            />
                        </div>)}

                        {isVisible("endDate") && (<div className={columnClass}>
                            <label className="me-1 fs-md fw-medium">End Date:</label>
                            <input
                                className="form-control form-control-sm"
                                name="endDate"
                                type="date"
                                value={filters.endDate}
                                onChange={(e) => handleChange("endDate", e.target.value)}
                            />
                        </div>)}
                    </div>
                </div>
                <div className={rightCol}>
                    <div className="d-flex d-xl-block justify-content-end mb-3 mb-xl-0">
                        <label className="me-1 fs-md d-none d-xl-block">&nbsp;</label>

                        <div className="d-flex">
                            <button
                                className="btn bg-primary bg-opacity-15 bg-opacity-25-hover py-2 px-4 d-flex align-items-center gap-2 fw-medium border-0 me-2 fs-sm"
                                type="button"
                                onClick={onApplyFilter}
                            >
                                Apply filter
                            </button>

                            <button
                                className="btn bg-secondary bg-opacity-15 bg-opacity-25-hover py-2 px-4 d-flex align-items-center gap-2 fw-medium border-0 fs-sm"
                                type="button"
                                onClick={onClearFilterHandler}
                            >
                                Reset
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FilterOrders;
